exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/diabetes.css"), undefined);

// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"low": "SMBGDatePointsAnimated--low--2QXpz " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/diabetes.css").locals["bgLow"] + "",
	"target": "SMBGDatePointsAnimated--target--1a27- " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/diabetes.css").locals["bgTarget"] + "",
	"high": "SMBGDatePointsAnimated--high--1tgZk " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/diabetes.css").locals["bgHigh"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/smbg/SMBGDatePointsAnimated.css
 ** module id = 147
 ** module chunks = 0
 **/